export enum Paths {
  Dashboard = '/',
  PointOfSales = '/point-of-sales',
  Underwear = '/underwear',
  PromoBanner = '/promo-banner',
  Login = '/login',
  GlowUp = '/glow-up',
  FoodSupplement = '/food-supplement',
  IdentifiedSymptom = '/identified-symptom',
  UnderwearPromotion = '/underwear-promotion',
}
